import React from 'react';
import { Link } from 'react-router-dom';
import { TwitterIcon, LinkedinIcon, GithubIcon, MailIcon, MapPinIcon, CheckCircleIcon } from 'lucide-react';
export const Footer = () => {
  return <footer className="bg-[#0F1115] text-gray-400 border-t border-gray-800 relative overflow-hidden" data-id="element-58">
      {/* Background decoration */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-px bg-gradient-to-r from-transparent via-gray-700 to-transparent opacity-50" data-id="element-59"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-60">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-12" data-id="element-61">
          {/* Brand */}
          <div className="md:col-span-5 space-y-6" data-id="element-62">
            <Link to="/" className="flex items-center gap-3 group w-fit" data-id="element-63">
              <div className="w-10 h-10 bg-white rounded-xl flex items-center justify-center shadow-lg group-hover:shadow-red-500/20 transition-all duration-300" data-id="element-64">
                <CheckCircleIcon className="w-6 h-6 text-[#d73b3e]" data-id="element-65" />
              </div>
              <span className="font-display font-bold text-2xl text-white tracking-tight" data-id="element-66">
                Certified<span className="text-[#d73b3e]" data-id="element-67">Devs</span>
              </span>
            </Link>
            <p className="text-base text-gray-400 leading-relaxed max-w-sm" data-id="element-68">
              The premier platform for connecting certified developers with top
              companies worldwide. We verify skills so you can hire with
              confidence.
            </p>
            <div className="flex gap-4 pt-2" data-id="element-69">
              <a href="#" className="w-10 h-10 rounded-full bg-[#1a1d24] flex items-center justify-center text-gray-400 hover:text-white hover:bg-[#d73b3e] transition-all duration-300 border border-gray-800 hover:border-[#d73b3e]" data-id="element-70">
                <TwitterIcon className="w-5 h-5" data-id="element-71" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-[#1a1d24] flex items-center justify-center text-gray-400 hover:text-white hover:bg-[#0077b5] transition-all duration-300 border border-gray-800 hover:border-[#0077b5]" data-id="element-72">
                <LinkedinIcon className="w-5 h-5" data-id="element-73" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-[#1a1d24] flex items-center justify-center text-gray-400 hover:text-white hover:bg-[#333] transition-all duration-300 border border-gray-800 hover:border-[#333]" data-id="element-74">
                <GithubIcon className="w-5 h-5" data-id="element-75" />
              </a>
            </div>
          </div>

          {/* Links Column 1 */}
          <div className="md:col-span-2 md:col-start-7" data-id="element-76">
            <h3 className="text-white font-semibold mb-6 text-lg" data-id="element-77">Platform</h3>
            <ul className="space-y-4 text-sm" data-id="element-78">
              <li data-id="element-79">
                <Link to="/developers" className="hover:text-[#d73b3e] transition-colors block" data-id="element-80">
                  Browse Talent
                </Link>
              </li>
              <li data-id="element-81">
                <Link to="/jobs" className="hover:text-[#d73b3e] transition-colors block" data-id="element-82">
                  Browse Jobs
                </Link>
              </li>
              <li data-id="element-83">
                <Link to="/pricing" className="hover:text-[#d73b3e] transition-colors block" data-id="element-84">
                  Pricing
                </Link>
              </li>
              <li data-id="element-85">
                <Link to="/how-it-works" className="hover:text-[#d73b3e] transition-colors block" data-id="element-86">
                  How it Works
                </Link>
              </li>
            </ul>
          </div>

          {/* Links Column 2 */}
          <div className="md:col-span-2" data-id="element-87">
            <h3 className="text-white font-semibold mb-6 text-lg" data-id="element-88">Resources</h3>
            <ul className="space-y-4 text-sm" data-id="element-89">
              <li data-id="element-90">
                <Link to="/blog" className="hover:text-[#d73b3e] transition-colors block" data-id="element-91">
                  Blog
                </Link>
              </li>
              <li data-id="element-92">
                <Link to="/success-stories" className="hover:text-[#d73b3e] transition-colors block" data-id="element-93">
                  Success Stories
                </Link>
              </li>
              <li data-id="element-94">
                <Link to="/verification" className="hover:text-[#d73b3e] transition-colors block" data-id="element-95">
                  Verification Process
                </Link>
              </li>
              <li data-id="element-96">
                <Link to="/faq" className="hover:text-[#d73b3e] transition-colors block" data-id="element-97">
                  FAQ
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-3" data-id="element-98">
            <h3 className="text-white font-semibold mb-6 text-lg" data-id="element-99">Contact</h3>
            <ul className="space-y-4 text-sm" data-id="element-100">
              <li className="flex items-start gap-3" data-id="element-101">
                <MailIcon className="w-5 h-5 text-[#d73b3e] mt-0.5" data-id="element-102" />
                <a href="mailto:hello@certifieddevs.com" className="hover:text-white transition-colors" data-id="element-103">
                  hello@certifieddevs.com
                </a>
              </li>
              <li className="flex items-start gap-3" data-id="element-104">
                <MapPinIcon className="w-5 h-5 text-[#d73b3e] mt-0.5" data-id="element-105" />
                <span data-id="element-106">
                  Keizersgracht 241
                  <br data-id="element-107" />
                  1016 EA Amsterdam
                  <br data-id="element-108" />
                  Netherlands
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-500" data-id="element-109">
          <p data-id="element-110">
            &copy; {new Date().getFullYear()} CertifiedDevs. All rights
            reserved.
          </p>
          <div className="flex gap-8" data-id="element-111">
            <Link to="/privacy" className="hover:text-white transition-colors" data-id="element-112">
              Privacy Policy
            </Link>
            <Link to="/terms" className="hover:text-white transition-colors" data-id="element-113">
              Terms of Service
            </Link>
            <Link to="/cookies" className="hover:text-white transition-colors" data-id="element-114">
              Cookie Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>;
};